export enum GameIds {
  DBD = 'dbd',
  MYM = 'mym',
  HOY = 'hoy',
  FM = 'fm',
}

export enum Stores {
  STEAM = 'steam',
  MICROSOFT = 'xbox',
  PLAYSTATION = 'playstation',
}

export interface MarketingPlayerSubscriptions {
  project: string;
  subscribedMessages: string[];
}
